import {
	SensorDataPoint,
	EditSensorDataSort,
} from '@Types/editSensorData.types';

export const editSensorDataInitialState = {
	points: [] as SensorDataPoint[],
	sort: {
		name: 'dataEditor-dateTime',
		order: 'desc',
	} as EditSensorDataSort,
};
